import React from 'react';

// Line icons from the redesign (24px grid, stroke = currentColor).
const PATHS = {
  home: <path d="M3 11l9-8 9 8M5 10v10h5v-6h4v6h5V10" />,
  info: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 11v6M12 7.5v.01" />
    </>
  ),
  book: <path d="M4 5h13v14H4zM17 8h3v11h-3M8 9h5M8 13h5" />,
  id: (
    <>
      <path d="M3 5h18v14H3z" />
      <circle cx="9" cy="11" r="2" />
      <path d="M6 16c.5-2 5.5-2 6 0M14 10h4M14 14h4" />
    </>
  ),
  phone: <path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z" />,
  mail: <path d="M3 5h18v14H3zM3 6l9 7 9-7" />,
  pin: (
    <>
      <path d="M12 21s7-6.2 7-11a7 7 0 0 0-14 0c0 4.8 7 11 7 11z" />
      <circle cx="12" cy="10" r="2.5" />
    </>
  ),
  chevron: <path d="M6 9l6 6 6-6" />,
};

const Icon = ({ name, className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={name === 'chevron' ? 2 : 1.8}
    aria-hidden="true"
    focusable="false"
  >
    {PATHS[name]}
  </svg>
);

export default Icon;
